export const STAGE = isLocal() ? 'local' : import.meta.env.VITE_APP_STAGE

export const API_URLS = {
  local: 'http://localhost:8000',
  alpha: 'https://api-alpha.tactrl.ai', // Not used
  development: 'https://api-dev.tactrl.ai',
  staging: 'https://api-staging.tactrl.ai',
  production: 'https://api.tactrl.ai',
}

export const API_URL = API_URLS[STAGE]

export const HERE_API_KEY = 'bTh0na4-sCovqZ9FZ0qC1ZfNbaXjUd0wOYOWFn8LQJs'

export const GOOGLE_API_KEY =
  process.env.NODE_ENV === 'production'
    ? 'AIzaSyAmbQWSI6QQm989pvmF6qpMIgDTuTgvZks'
    : 'AIzaSyDTKbfMhsq-FvgXA1t9JUdYffOCGzK50oU'

export function isLocal() {
  return process.env.NODE_ENV !== 'production'
}

const FLEET_URLS = {
  local: 'http://localhost:3001',
  alpha: 'https://fleet-alpha.tactrl.ai', // Not used
  development: 'https://fleet-dev.tactrl.ai',
  staging: 'https://fleet-staging.tactrl.ai',
  production: 'https://fleet.tactrl.ai',
}

export const FLEET_URL = FLEET_URLS[STAGE]

const PLANNER_URLS = {
  local: 'http://localhost:3002',
  alpha: 'https://planner-alpha.tactrl.ai', // Not used
  development: 'https://planner-dev.tactrl.ai',
  staging: 'https://planner-staging.tactrl.ai',
  production: 'https://planner.tactrl.ai',
}

export const PLANNER_URL = PLANNER_URLS[STAGE]
